<p-dialog class="scrollableDialog" [header]="workOrder.serviceType + ': ' + workOrder.number" [(visible)]="showDialog" [modal]="true" [blockScroll]="false" (onHide)="closeAndRefresh()" [style]="{width: '515px'}">
  <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
  @if (!isLoading) {
    <span>
      <h6>Cash Collected:</h6>
      @if (cashCollected.length == 0) {
        <span class="fine-print" style="margin-bottom: 5px;">No Cash or Check Collected</span>
      }
      @for (cash of cashCollected; track cash; let i = $index) {
        <div class="container" style="flex-wrap: nowrap;">
          <label for="total" style="margin: auto;"><span class="totalLabel">Value of Cash or Check Collected</span>&nbsp;&nbsp;</label>
          @if (workOrder) {
            <input
              pInputText
              [name]="'cashCollected' + i"
              [textMask]="{mask: currencyMask, placeholderChar: '\u2000'}"
              [ngModel]="cash.amount"
              [disabled]="!(!workOrder.paymentStatus || workOrder.paymentStatus === 'Not Paid') || cash.invoiced || disableApply"
              class="total-boxes"
              (ngModelChange)="cashCollectedChange($event, i)"
              required
              />
          }
          <p-button 
            [disabled]="cash.invoiced || (workOrder.paymentStatus && workOrder.paymentStatus !== 'Not Paid') || disableApply"
            type="button"
            severity="danger"
            (click)="removeCashCollectedEntry(i)"
            icon="pi pi-trash">
          </p-button>
        </div>
      }
      <div class="inner-container">
        @if (!this.workOrder.paymentStatus || this.workOrder.paymentStatus === 'Not Paid') {
          <p-button 
            [disabled]="disableApply"
            type="button"
            class="ui-button-primary"
            (click)="pushNewCashCollectedEntry()"
            label="Add Cash  Collected">
          </p-button>
        }
        @if (!this.workOrder.paymentStatus || this.workOrder.paymentStatus === 'Not Paid') {
          <p-button 
            [disabled]="disableApply"
            type="button"
            severity="success"
            (click)="saveCashCollectedEntry()"
            label="Save Cash Collected">
          </p-button>
        }
      </div>
      <hr/>
      <h6>Invoices:</h6>
      @for (invoice of workOrder.invoices; track invoice) {
        <div class="container">
          <div class="bold header-line">
            Invoice: <span class="regular-link" (click)="navigate(invoice.invoiceUrl)">{{invoice.invoiceNumber}}</span>
            <span style="float: right;">Status: {{invoice.status | titlecase}}</span>
          </div><br/>
          <div>Created: {{invoice.created | date: 'shortDate'}}</div>
          <div>Amount Due: {{invoice.amountDue | currency: 'USD'}}</div>
          <div>Amount Paid: {{invoice.amountPaid | currency: 'USD'}}</div>
          @if (invoice.datePaid) {
            <div>Paid On: {{invoice.datePaid | date: 'shortDate' }}</div>
          }
          @if (invoice.refunded || invoice.amountRefunded > 0) {
            <div></div>
          }
          @if (invoice.refunded) {
            <div>Amount Refunded: {{invoice.amountRefunded | currency: 'USD' }}</div>
          }
          @if (invoice.status == 'open') {
            <div class="inner-container">
              <ng-select
                #selectDropdown
                style="min-width: 200px"
                class="custom"
                [selectOnTab]="true"
                [items]="nonInvoicedCashCollected"
                placeholder="Select a Cash Amount"
                name="cashAmount"
                (change)="setCashIdToApply(invoice, $event)"
                bindLabel="amount">
                <ng-template ng-option-tmp ng-label-tmp let-item="item">
                  {{item.amount | currency: 'USD'}}
                </ng-template>
              </ng-select>
              <p-button
                type="button"
                severity="success"
                label="Apply Now"
                [disabled]="disableApply"
                (click)="applyCashToInvoice(invoice)">
              </p-button>
              @if (invoice.status == 'open') {
                <div class="charge-container">
                  <p-button
                    type="button"
                    class="ui-button-warning"
                    label="Charge Card"
                    [disabled]="disableApply"
                    (click)="chargeCardForInvoice(invoice)">
                  </p-button>
                </div>
              }
            </div>
          }
        </div>
      }
    </span>
  }
  <div class="footer">
    <p-button type="button" (click)="closeAndRefresh()" label="Close" severity="info"></p-button>
  </div>
</p-dialog>